<template>
    <b-row>
        <b-col cols="12">
          <search-view :click-search="getInstallations"/>
        </b-col>
        <b-col cols="12">
            <b-card title="">
                <b-overlay
                    variant="white"
                    :show="showLoading"
                    spinner-variant="primary"
                    blur="0"
                    opacity=".75"
                    rounded="sm"
                >
                    <div class="ml-1 mb-2">
                        <b-row>
                            <b-col cols="12" md="9"
                                   class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                            >
                                <label>Mostrar</label>
                                <v-select
                                    v-model="pageLength"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    :options="['3','5','10','20']"
                                    :clearable="false"
                                    class="per-page-selector d-inline-block mx-50"
                                    @input="changeLength"
                                />
                                <button class="btn btn-primary" @click="exportToExcel">Exportar a Excel</button>
                            </b-col>
                        </b-row>
                    </div>

                    <b-table
                        ref="refUserListTable"
                        class="position-relative table-size-list"
                        :items="masters_installations"
                        responsive
                        striped
                        sticky-header
                        :fields="columns"
                        primary-key="id"
                        show-empty
                        empty-text="No hay registros"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        @head-clicked="handleHeaderClick"
                    >

                        <template #cell(client_cif)="data">
                            {{ data.item.client_cif }}
                        </template>

                        <template #cell(installation_code)="data">
                            {{ data.item.installation_code }}
                        </template>

                        <template #cell(active)="data">
                            <b-badge :variant="data.item.active === 1 ? 'success' : 'danger'">
                                {{ data.item.active === 1 ? 'Si' : 'No' }}
                            </b-badge>
                        </template>

                        <template #cell(draft)="data">
                            <b-badge :variant="data.item.draft === 1 ? 'success' : 'danger'">
                                {{ data.item.draft === 1 ? 'Si' : 'No' }}
                            </b-badge>
                        </template>

                        <template #cell(responsible)="data">
                            {{ data.item.responsible ? data.item.responsible.name : null }}
                        </template>

                        <template #cell(figure)="data">
                            {{ figures[data.item.figure_id - 1] ? figures[data.item.figure_id - 1].name : null }}
                        </template>

                        <template #cell(start_date)="data">
                            {{ data.item.start_date ? helpers.formatDate(data.item.start_date) : null }}
                        </template>

                        <template #cell(end_date)="data">
                            {{ data.item.end_date ? helpers.formatDate(data.item.end_date) : null }}
                        </template>

                        <template #cell(period_description)="data">
                            {{ data.item.period_description }}
                        </template>

                        <template #cell(client)="data">
                            {{ data.item.client }}
                        </template>

                        <template #cell(country)="data">
                            {{ data.item.province_country ? data.item.province_country.country : null }}
                        </template>

                        <template #cell(address)="data">
                            {{ data.item.address }}
                        </template>

                        <template #cell(province_country)="data">
                            {{ data.item.province_country ? data.item.province_country.province : null }}
                        </template>

                        <template #cell(city)="data">
                            {{ data.item.city }}
                        </template>

                        <template #cell(postal_code)="data">
                          {{ data.item.postal_code }}
                        </template>

                        <template #cell(installation_type)="data">
                            {{ data.item.typology ? data.item.typology.name : null }}
                        </template>

                        <template #cell(opsva_territory)="data">
                            {{ data.item.opsva_territory ? data.item.opsva_territory.name : null }}
                        </template>

                        <template #cell(client_type)="data">
                            {{ data.item.client_type ? data.item.client_type.type : null }}
                        </template>

                        <template #cell(latitud)="data">
                            {{ data.item.latitude }}
                        </template>

                        <template #cell(longitud)="data">
                            {{ data.item.longitude }}
                        </template>

                        <template #cell(client_contact_person)="data">
                            {{ data.item.client_contact_person }}
                        </template>

                        <template #cell(client_phone)="data">
                            {{ data.item.client_phone }}
                        </template>

                        <template #cell(client_email)="data">
                            {{ data.item.client_email }}
                        </template>

                        <template #cell(company)="data">
                            {{ data.item.company ? data.item.company.name : null }}
                        </template>

                        <template #cell(observations)="data">
                            {{ data.item.observations }}
                        </template>
                    </b-table>
                  <div class="mx-2 mb-2">
                    <b-row>
                      <b-col
                          cols="12"
                          sm="6"
                          class="d-flex align-items-center justify-content-center justify-content-sm-start"
                      >
                        <span class="text-muted">Mostrando {{ pageLength }} de {{ totalRecords }} Instalaciones</span>
                      </b-col>

                      <b-col
                          cols="12"
                          sm="6"
                          class="d-flex align-items-center justify-content-center justify-content-sm-end"
                      >
                        <b-pagination
                            :value="1"
                            :total-rows="totalRecords"
                            :per-page="pageLength"
                            first-number
                            last-number
                            align="right"
                            prev-class="prev-item"
                            next-class="next-item"
                            class="mt-1 mb-0"
                            @input="changePage"
                        >
                          <template #prev-text>
                            <feather-icon
                                icon="ChevronLeftIcon"
                                size="18"
                            />
                          </template>
                          <template #next-text>
                            <feather-icon
                                icon="ChevronRightIcon"
                                size="18"
                            />
                          </template>
                        </b-pagination>
                      </b-col>
                    </b-row>
                  </div>
                </b-overlay>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import {BRow, BCol, BTable, BCard, BOverlay, BBadge, BPagination} from 'bootstrap-vue'
import {mapState} from "vuex"
import helpers from "@/resources/helpers/helpers"
import ExcelJS from "exceljs"
import SearchView from "@/views/gei/dashboard_metrics/list/components/masterInstallationsSearchView.vue"
import vSelect from "vue-select"

export default {
    name: "ListView",
    components: {
        BPagination,
        vSelect,
        SearchView,
        BRow,
        BCol,
        BTable,
        BCard,
        BOverlay,
        BBadge,
    },
    data() {
        return {
            columns: [
                {key: 'client_cif', label: 'CIF', sortable: true, class: 'sortable-column'},
                {key: 'installation_code', label: 'Código instalación', sortable: true, class: 'sortable-column'},
                {key: 'active', label: 'InstalaciónActiva', sortable: true, class: 'sortable-column'},
                {key: 'draft', label: 'InstalaciónBorrador', sortable: true, class: 'sortable-column'},
                {key: 'client', label: 'Cliente', sortable: true, class: 'sortable-column'},
                {key: 'proceeding_code', label: 'Expediente OR', sortable: true, class: 'sortable-column'},
                {key: 'responsible', label: 'Responsable', sortable: true, class: 'sortable-column'},
                {key: 'figure', label: 'Figura RD171', sortable: true, class: 'sortable-column'},
                {key: 'country', label: 'Pais', sortable: false},
                {key: 'address', label: 'Dirección Gei', sortable: true, class: 'sortable-column'},
                {key: 'province_country', label: 'Provincia/Zona', sortable: false},
                {key: 'city', label: 'Población', sortable: true, class: 'sortable-column'},
                {key: 'postal_code', label: 'Código Postal', sortable: true, class: 'sortable-column'},
                {key: 'installation_type', label: 'Tipo de instalación', sortable: true, class: 'sortable-column'},
                {key: 'start_date', label: 'Fecha inicio explotación', sortable: true, class: 'sortable-column'},
                {key: 'end_date', label: 'Fecha fin explotación', sortable: true, class: 'sortable-column'},
                {key: 'period_description', label: 'Duración', sortable: true, class: 'sortable-column'},
                {key: 'opsva_territory', label: 'Territorio_OPSVA', sortable: true, class: 'sortable-column'},
                {key: 'client_type', label: 'Tipo cliente', sortable: true, class: 'sortable-column'},
                {key: 'latitude', label: 'Coordenada X', sortable: true, class: 'sortable-column'},
                {key: 'longitude', label: 'Coordenada Y', sortable: true, class: 'sortable-column'},
                {key: 'client_contact_person', label: 'Contacto', sortable: true, class: 'sortable-column'},
                {key: 'client_phone', label: 'Teléfono', sortable: true, class: 'sortable-column'},
                {key: 'client_email', label: 'Email', sortable: true, class: 'sortable-column'},
                {key: 'company', label: 'Empresa', sortable: true, class: 'sortable-column'},
                {key: 'observations', label: 'Observaciones', sortable: false},
            ],
            showLoading: false,
            helpers,

            figures: [
                { 'id' : 1, 'name': 'MANTENEDOR' },
                { 'id' : 2, 'name': 'PROPIETARIO' },
                { 'id' : 3, 'name': 'TITULAR' }
            ],
            page: 1,
            pageLength: 10,
            totalRecords: 10,
            sortBy: null,
            sortDesc: false,
        }
    },
    computed: {
        ...mapState('masterInstallation', ['masters_installations','search']),
    },
    created() {
        this.getInstallations()
    },
    methods: {
        can(permission) {
            return this.$store.getters.can(permission)
        },
        formatDate(date) {
            const dateFormated = new Date(date)

            return dateFormated.toLocaleDateString("es-ES")
        },
        getInstallations() {
            this.showLoading = true

            let filteredSearch = JSON.parse(JSON.stringify(this.search))


            if (!filteredSearch.companies || filteredSearch.companies.length < 1){
              const userCompanies = this.$store.state.AppActiveUser.companies
              filteredSearch.companies = userCompanies.map(company => company.id)
            }

            this.$store.dispatch('masterInstallation/searchMasterInstallations', {
                relations: ['company', 'responsible', 'clientType', 'opsvaTerritory', 'provinceCountry','typology'],
                per_page: this.pageLength,
                page: this.page,
                filter: filteredSearch,
            })
                .then(response => {
                  this.showLoading = false
                  this.totalRecords = response.total_records
                })
                .catch(error => {
                    this.showLoading = false
                    console.log(error)
                })
        },
        async fetchAllInstallations() {
          try {
            const response = await this.$store.dispatch('masterInstallation/searchMasterInstallations', {
              relations: ['company', 'responsible', 'clientType', 'opsvaTerritory', 'provinceCountry'],
              per_page: this.totalRecords,
              page: 1,
              filter: this.search,
            })

            return response.data
          } catch (error) {
            console.error('Error al obtener todos los registros:', error)
            return []
          }
        },
        async exportToExcel() {

            const allInstallations = await this.fetchAllInstallations()

            this.changeLength(this.length)

            const workbook = new ExcelJS.Workbook()
            const worksheet = workbook.addWorksheet('InstalacionesGEI')

            const headers = [
                'CIF',
                'Código instalación',
                'InstalaciónActiva',
                'InstalaciónBorrador',
                'Cliente',
                'Responsable',
                'Figura RD171',
                'Pais',
                'Dirección Gei',
                'Provincia/Zona',
                'Población',
                'Tipo Instalación',
                'Fecha inicio explotación',
                'Fecha fin explotación',
                'Duración',
                'Territorio_OPSVA',
                'Tipo cliente',
                'Coordenada X',
                'Coordenada Y',
                'Contacto',
                'Teléfono',
                'Email',
                'Empresa',
                'Observaciones'
            ]

            worksheet.addRow(headers)

            allInstallations.forEach(detail => {
                worksheet.addRow([
                    detail.client_cif,
                    detail.installation_code,
                    detail.active === 1 ? 'Si' : 'No',
                    detail.draft === 1 ? 'Si' : 'No',
                    detail.client,
                    detail.responsible ? detail.responsible.name : null,
                    this.figures[detail.figure_id - 1] ? this.figures[detail.figure_id - 1].name : null,
                    detail.province_country ? detail.province_country.country : null,
                    detail.address,
                    detail.province_country ? detail.province_country.province : null,
                    detail.city,
                    detail.installation_type ? detail.installation_type.type : null,
                    detail.start_date ? helpers.formatDate(detail.start_date) : null,
                    detail.end_date ? helpers.formatDate(detail.end_date) : null,
                    detail.period_description,
                    detail.opsva_territory ? detail.opsva_territory.name : null,
                    detail.client_type ? detail.client_type.type : null,
                    detail.latitude,
                    detail.longitude,
                    detail.client_contact_person,
                    detail.client_phone,
                    detail.client_email,
                    detail.company ? detail.company.name : null,
                    detail.observations
                ])
            })

            // Generar el archivo Excel
            const buffer = await workbook.xlsx.writeBuffer()

            // Crear un Blob para la descarga
            const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})

            // Crear una URL para el Blob
            const url = window.URL.createObjectURL(blob)

            // Crear un enlace de descarga y hacer clic en él
            const a = document.createElement('a')
            a.href = url
            a.download = 'instalacionesGEI.xlsx'
            a.click()

            // Liberar recursos
            window.URL.revokeObjectURL(url)
        },
        changePage(page) {
          this.page = page
          this.getInstallations()
        },
        changeLength(length) {
          this.length = length
          this.getInstallations()
        },
        handleHeaderClick(field) {
          if (this.sortBy === field) {
            this.sortDesc = !this.sortDesc
          } else {
            this.sortBy = field
            this.sortDesc = false
          }

          this.showLoading = true

          this.$store.dispatch('masterInstallation/searchMasterInstallations', {
            relations: ['company', 'responsible', 'clientType', 'opsvaTerritory', 'provinceCountry'],
            per_page: this.pageLength,
            page: this.page,
            filter: this.search,
            order_filter: this.sortDesc ? 'desc' : 'asc',
            column_order_filter: field,
          }).then(response => {
            this.showLoading = false
            this.totalRecords = response.total_records
          })
              .catch(error => {
                this.showLoading = false
                console.log(error)
              })

        },
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';

.sortable-column {
  cursor: pointer;
}

.sortable-header {
  display: flex;
  align-items: center;
  gap: 5px;
}

</style>